import styled from 'styled-components';

export const IconContainer = styled('i')`
  display: ${props => (props.flex === false ? 'unset' : 'flex')};
  height: ${props => `${props.size}px`};
  color: ${props => props.color};
  font-size: ${props => `${props.size}px`};
  cursor: ${props => (props.onClick ? 'pointer' : '')};
`;
